import { downloadData, getData, postData } from '../../apis/api.helpers'
import apiUrl from '../../apis/api.url'
import { parseQueryParams } from '../../utilities/parsers'

export const exportOrgDataTable = (type: string, input?: any) => {
  return downloadData(
    `${apiUrl.ORGANISATION_DATATABLES}/${type}/export${parseQueryParams(input)}`
  )
}
export const exportOrganisationUpdateDataTable = (input?: any) => {
  return downloadData(
    `${apiUrl.UPDATE_ORGANISATION_DATATABLES_EXPORT}${parseQueryParams(input)}`
  )
}
export const getDataTables = (orgId?: string, type?: string, params?: any) => {
  return getData(
    `${apiUrl.ORGANISATION_LIST_URL}/${apiUrl.ORGANISATION_DATATABLES}/${type}${parseQueryParams(params)}`
  )
}
export const getOrgDataTables = (type?: string, params?: any) => {
  return getData(
    `${apiUrl.ORGANISATION_DATATABLES}/${type}${parseQueryParams(params)}`
  )
}
export const getPrimaryLocationHistory = () => {
  return getData(`datatable/assign-workforce-locations`)
}
export const updateOrgDataTables = (data: any, type?: string) => {
  return postData(`${apiUrl.ORGANISATION_DATATABLES}/${type}`, data)
}
export const updateWorkForceLocation = (data: any) => {
  return postData(`datatable/assign-workforce-locations`, data)
}
export const exportDataTable = (type: string, params?: any) => {
  return downloadData(
    `${apiUrl.ORGANISATION_LIST_URL}/${apiUrl.ORGANISATION_DATATABLES}/${type}/export${parseQueryParams(params)}`
  )
}
export const getOrgList = () => {
  return getData(`organisations/datatable/organisations-list`)
}
export const getOrgDataTableUpdateReport = (params?: any) => {
  return getData(
    `organisations/datatable/update-report${parseQueryParams(params)}`
  )
}
export const getEngagementReport = (params?: any) => {
  return getData(
    `organisations/datatable/engagement-report${parseQueryParams(params)}`
  )
}
export const getAccreditationCycleReport = (params?: any) => {
  return getData(
    `organisations/datatable/accreditation-cycle-report${parseQueryParams(params)}`
  )
}
export const getAccreditationDeadlineReport = (params?: any) => {
  return getData(
    `organisations/datatable/accreditation-deadline-report${parseQueryParams(params)}`
  )
}
